import { Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import clsx from 'clsx';

const checkIcon = '/-/media/Project/FAB2/Fab2/data/media/svgs/icons/icon-checkbox-button-selected';

const SingleFilter = ({
  data,
  allFilters,
  setAllFilters,
  setNumberOfSelectedCheckboxes,
  rounded = true,
  type = '',
}) => {
  const checked =
    allFilters?.servicesFilter.some((item) => item === data?.id) ||
    allFilters?.locationFilter.some((item) => item === data?.id) ||
    allFilters?.bankingExperienceFilter.some((item) => item === data?.id);

  const shouldRenderTitle = !!data?.fields?.title?.value;

  const filterClick = () => {
    if (checked) {
      if (type === 'services') {
        setAllFilters((prev) => {
          return {
            ...prev,
            servicesFilter: prev.servicesFilter.filter((item) => item !== data?.id),
          };
        });
      } else if (type === 'location') {
        setAllFilters((prev) => {
          return {
            ...prev,
            locationFilter: prev.locationFilter.filter((item) => item !== data?.id),
          };
        });
      } else if (type === 'bankingExperience') {
        setAllFilters((prev) => {
          return {
            ...prev,
            bankingExperienceFilter: prev.bankingExperienceFilter.filter(
              (item) => item !== data?.id
            ),
          };
        });
      }
      setNumberOfSelectedCheckboxes((prev) => --prev);
    } else {
      if (type === 'services') {
        setAllFilters((prev) => {
          return {
            ...prev,
            servicesFilter: [...prev.servicesFilter, data?.id],
          };
        });
      } else if (type === 'location') {
        setAllFilters((prev) => {
          return {
            ...prev,
            locationFilter: [...prev.locationFilter, data?.id],
          };
        });
      } else if (type === 'bankingExperience') {
        setAllFilters((prev) => {
          return {
            ...prev,
            bankingExperienceFilter: [...prev.bankingExperienceFilter, data?.id],
          };
        });
      }
      setNumberOfSelectedCheckboxes((prev) => ++prev);
    }
  };

  return (
    <div
      role="button"
      onClick={filterClick}
      className={clsx(
        'branches__wrapper-top_filter',
        rounded && 'rounded-div',
        checked && 'checked'
      )}
    >
      <div className={clsx('checkmark', checked && 'checked')}>
        <img src={checkIcon} alt="check" />
      </div>
      {shouldRenderTitle && <Text field={data.fields.title} />}
    </div>
  );
};

export default SingleFilter;
